import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  fetchOperators,
  updateOperatorField,
  type Operator,
} from '../../services/operators-api';

export const OPERATORS_QUERY_KEY = ['operators'];

export function useOperators() {
  return useQuery({
    queryKey: OPERATORS_QUERY_KEY,
    queryFn: fetchOperators,
  });
}

export function useUpdateOperator() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      id,
      field,
      value,
    }: {
      id: string;
      field: string;
      value: string | number | boolean | string[] | null;
    }) => {
      await updateOperatorField(id, field, value);
      return { id, field, value };
    },
    onSuccess: ({ id, field, value }) => {
      // Update the cache optimistically
      queryClient.setQueryData(
        OPERATORS_QUERY_KEY,
        (old: Operator[] | undefined) => {
          if (!old) return old;
          return old.map(operator =>
            operator.id === id ? { ...operator, [field]: value } : operator
          );
        }
      );
    },
  });
}

export function useRefreshOperators() {
  const queryClient = useQueryClient();

  return () => {
    queryClient.invalidateQueries({ queryKey: OPERATORS_QUERY_KEY });
  };
}
